export default {
      id: "manufacturer-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#manufacturer",
      toString: function () {
        return this.url;
      }
    }